// extracted by mini-css-extract-plugin
export default {"fs":"_002a267246 de4fbbd516"};